var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefusable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.141601px",
    height: "16px",
    viewBox: "0 0 15.141601 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u53EF\u62D2\u7EDD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u53EF\\u62D2\\u7EDD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.000000, 1.000000)",
    fill: "#F2A100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8104488,1.51416009 L11.8104488,7.81556448 C11.2011508,7.25547666 10.5450652,7.16212869 10.0294937,7.16212869 C8.6657654,7.16212869 7.3598023,8.96685612 8.47414843,10.2291357 C8.57983681,10.34883 8.6545606,10.498959 8.64608131,10.6581729 C8.60731881,11.3808816 8.38269317,11.4426593 7.94017987,11.5643978 C7.90883677,11.5729528 7.87650944,11.5818863 7.84304651,11.5913498 C6.51376533,12.1043473 6.071782,13.0224583 6.21093331,13.9302729 L6.21093331,13.9302729 L0,13.9302729 L0,1.51416009 L11.8104488,1.51416009 Z M5.80112589,9.18432736 L1.66084436,9.18432736 L1.66084436,10.5470715 L5.80112589,10.5470715 L5.80112589,9.18432736 Z M7.41465275,6.8279157 L1.66084436,6.8279157 L1.66084436,8.19065979 L7.41465275,8.19065979 L7.41465275,6.8279157 Z M7.41465275,4.47150404 L1.66084436,4.47150404 L1.66084436,5.83424813 L7.41465275,5.83424813 L7.41465275,4.47150404 Z",
    id: "\\u8DEF\\u5F84-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fillRule: "nonzero",
    points: "2.9526122 0 9.00925261 0 9.00925261 1.74128411 2.9526122 1.74128411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1197863,9.4786044 C9.11973085,9.90342808 9.34633974,10.2960051 9.71423861,10.5084329 C10.0821375,10.7208608 10.5354236,10.7208608 10.9033224,10.5084329 C11.2712213,10.2960051 11.4978302,9.90342808 11.4977747,9.4786044 C11.4978302,9.05378071 11.2712213,8.66120371 10.9033224,8.44877586 C10.5354236,8.23634801 10.0821375,8.23634801 9.71423861,8.44877586 C9.34633974,8.66120371 9.11973085,9.05378071 9.1197863,9.4786044 L9.1197863,9.4786044 Z",
    id: "\\u8DEF\\u5F84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64133874,10.3683627 L9.64133874,10.02215 L10.5274252,10.02215 L10.5274252,11.9929051 L9.21358852,11.9929051 C9.27468488,11.8597347 9.44578497,11.593394 9.64133874,11.5933939 C9.8368925,11.5933939 9.92653078,11.3626359 9.94689626,11.2471812 L9.94689626,10.6613527 C9.94689626,10.4482347 9.74316602,10.3772206 9.64133874,10.3683627 L9.64133874,10.3683627 Z",
    id: "\\u8DEF\\u5F84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9442735,10.3683627 L10.9442735,10.02215 L10.058187,10.02215 L10.058187,11.9929051 L11.3720237,11.9929051 C11.3109274,11.8597347 11.1398273,11.593394 10.9442735,11.5933939 C10.7487198,11.5933939 10.6590815,11.3626359 10.638716,11.2471812 L10.638716,10.6613527 C10.638716,10.4482347 10.8423705,10.3772206 10.9442735,10.3683627 L10.9442735,10.3683627 Z",
    id: "\\u8DEF\\u5F84",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33671136,13.5904954 C7.33671136,12.9873297 7.82563365,12.4984832 8.42872362,12.4984832 L12.1568886,12.4984832 C12.7599786,12.4984832 13.2489009,12.9873297 13.2489009,13.5904954 C13.2489009,13.8166412 13.0655421,13.9999582 12.8393963,14 L7.74621596,14 C7.52005281,14 7.33671136,13.8166585 7.33671136,13.5904954 Z",
    id: "\\u8DEF\\u5F84"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefusable);
export default __webpack_public_path__ + "static/media/refusable.6b72ac06.svg";
export { ForwardRef as ReactComponent };